export var Global = {
    //url: 'http://api.tsm.cl:8010/api/', /* Productivo */
    //url: 'http://localhost:8010/api/', /* Pruebas locales */
    url: "/api/", /*build*/
    
    appName: 'RPA Documentos Electrónicos',
    appVersion: '1.0.0'
}